import { routeName } from '@/constants/routeName';
import { hubSelectorDisabler } from '@/router-middleware';
import DeliveryChargeAreaControl from '@V/DeliveryChargeAreaControl/index.vue';
import basicOptions from '@/router/basic-options';
export default [
    {
        path: 'delivery-charge-area-control',
        name: routeName.DELIVERY_CHARGE_AREA_CONTROL,
        component: DeliveryChargeAreaControl,
        meta: {
            ...basicOptions,
            middleware: [
                hubSelectorDisabler,
            ],
        },
    },
];
